"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeToastNotification = exports.showToastNotification = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var constants_1 = require("./constants");
exports.showToastNotification = (0, typesafe_actions_1.createStandardAction)(constants_1.SHOW_TOAST_NOTIFICATION)();
exports.closeToastNotification = (0, typesafe_actions_1.createStandardAction)(constants_1.CLOSE_TOAST_NOTIFICATION)();